import { StyledCardTitle } from "../../../styles/pages/AcademicActivityPlanStyles";
import { StyledCard } from "../../../styles/pages/GestaoFaltas/GestaoFaltas";

const EmptyWorkflow = () => {
    return (
        <StyledCard>
            <StyledCardTitle>Nenhum registro encontrado</StyledCardTitle>
        </StyledCard>
    );
};

export default EmptyWorkflow;
